"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailServiceApi = void 0;
/* eslint-disable import/prefer-default-export */
var emailService_1 = require("./api/emailService");
Object.defineProperty(exports, "emailServiceApi", { enumerable: true, get: function () { return __importDefault(emailService_1).default; } });
